import { RoomAvailabilitiesRead } from '@/api';

import { HelpersKey } from '@/plugins/helpers';
import debounce from 'lodash/debounce';
import { inject, onMounted, computed } from 'vue';
import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';

export default function useRoomTypesStore() {
  const store = useStore();
  onMounted(async () => {
    if (!store.state.roomTypes.roomTypes.length) {
      await store.dispatch('roomTypes/fetchRoomTypes');
    }
  });

  const helpers = inject(HelpersKey)!;
  const { locale } = useI18n({ useScope: 'global' });
  const allRoomTypes = computed(() => store.state.roomTypes.roomTypes);
  const roomTypes = (location: string | number | Record<string, any>) => {
    const locationIri = helpers.getIRI(location, '/api/locations');
    return (store.state.roomTypes?.roomTypes ?? [])
      .filter((roomType) => roomType.location === locationIri)
      .map((roomType) => ({
        ...roomType,
        name: helpers.getItemTranslation(roomType, locale.value),
      }));
  };

  const getAvailableRoomTypes = debounce(
    async (
      startDate: string,
      endDate: string,
      location?: string | number | Record<string, any>,
    ) => {
      if (!startDate || !endDate || !location) {
        return [];
      }
      const locationId = helpers.extractID(location);
      return (await store.getters['roomTypes/fetchAvailability'](
        { startDate, endDate },
        locationId,
      )) as RoomAvailabilitiesRead[];
    },
    250,
    { leading: true, trailing: true },
  );

  return {
    allRoomTypes,
    roomTypes,
    getAvailableRoomTypes,
  };
}
